export default __webpack_public_path__ + "static/media/google.69aa42d8.png";